export default {
  overruleResult: 'Ergebnis korrigieren',
  overruleReason: 'Grund für die Korrektur',
  overruleResultLabel: 'Korrigiertes Ergebnis',
  valueSensorMeaningsPlaceholder: 'Hauptsignal auswählen',
  durationMeaningsPlaceholder: 'Dauersignal auswählen',
};
